import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * The learner-facing "submit / check" pill used by interactive blocks (rating,
 * poll, word-cloud, open-ended, complete-sentence, card-sorting). One definition
 * so every block's action button is identical — a shadcn `Button` (rule 1) shaped
 * as the Figma pill. Colors come from the theme via `Button`'s `bg-primary`.
 */
export function PreviewButton({
    className,
    ...props
}: React.ComponentProps<typeof Button>) {
    return (
        <Button
            className={cn(
                // These make cn drop Button's `text-sm font-medium`, which
                // otherwise race the label style on CSS load order.
                "h-auto self-center rounded-full px-8 py-2.5 lomda-v3-text-label text-[length:var(--lomda-size-label)] font-[number:var(--lomda-weight-label)] leading-[var(--lomda-line-label)]",
                className
            )}
            {...props}
        />
    );
}
